import { render, staticRenderFns } from "./AssassinationNotif.vue?vue&type=template&id=46697245&"
import script from "./AssassinationNotif.vue?vue&type=script&lang=js&"
export * from "./AssassinationNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports